export default __webpack_public_path__ + "static/media/b1.aba3bb18.png";